// ──────────────────────────────────────────────────────────────────────────
// statsFormat.js — Utility di formattazione per la pagina Statistiche
// del Diario Operativo (sotto-tab Sintesi, Per sistema, Matrici, Confronto).
//
// Estratte da DiarioStatisticheSintesi.js (v130) in v131 per riuso tra
// i 4 sotto-tab. Logica identica all'originale, byte-per-byte.
// Architettura riusabile (D91 v129) — generiche, riusabili anche per
// la futura pagina Statistiche generale (TASK 5).
// ──────────────────────────────────────────────────────────────────────────

export const fmtEur = (n, decimali = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const seg = Math.abs(n).toLocaleString("it-IT", {
    minimumFractionDigits: decimali, maximumFractionDigits: decimali,
  });
  return (n < 0 ? "−" : "") + seg + " €";
};

export const fmtPct = (n, decimali = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const s = n > 0 ? "+" : (n < 0 ? "−" : "");
  return s + Math.abs(n).toFixed(decimali) + "%";
};

export const fmtNum = (n, decimali = 0) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("it-IT", {
    minimumFractionDigits: decimali, maximumFractionDigits: decimali,
  });
};

export const fmtData = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y.slice(2)}`;
};
